import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  windowsSize: {},
  user: "" || localStorage.getItem("user"),
};

const GlobalSlice = createSlice({
  name: "GlobalSlice",
  initialState,
  reducers: {
    setWindowsSize: (state, action) => {
      localStorage.setItem("WindowsSize", action.payload);
      state.windowsSize = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
  },
});
export const { setWindowsSize, setUser } = GlobalSlice.actions;

export default GlobalSlice.reducer;
